import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { HammerModule } from '@angular/platform-browser';

import { MgIconModule } from '@app/src/app/icon';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { CountTileModule } from '@shared/components/count-tile';
import { ArrayPipesModule } from '@shared/pipes';

import { CountTileCarouselComponent } from './count-tile-carousel.component';

@NgModule({
  imports: [
    ArrayPipesModule,
    MgIconModule,
    MgSpinnerModule,
    CountTileModule,
    CommonModule,
    FlexLayoutModule,
    HammerModule,
    MatTabsModule,
  ],
  declarations: [CountTileCarouselComponent],
  exports: [CountTileCarouselComponent],
})
export class CountTileCarouselModule {}
